import React, { useEffect, useState } from 'react';
import Script from 'next/script';
import BlockWrapper from '../BlockWrapper';
import Container from '../../interface/Container';
import { FormWrapper, Title } from './MindBodyWidget.styles';

const MindBodyBrandedWebWidgetBlock = ({ block }) => {
  const [mindBodyCode, setMindBodyCode] = useState(false);

  useEffect(() => {
    setMindBodyCode(
      '<mindbody-widget data-widget-type="' +
      block.dataType +
      '" data-widget-id="' +
      block.widgetId +
      '" class="mindbody-widget"' +
      ' />'
    );

    return () => {
      setMindBodyCode('');
    };
  });

  return (
    <BlockWrapper>
      <Container>
        {block.mainTitle && <Title>{block.mainTitle}</Title>}
        <Script
          async src="https://brandedweb.mindbodyonline.com/embed/widget.js"
          type="text/javascript"
          strategy="afterInteractive"
        />
        <FormWrapper>
          <div dangerouslySetInnerHTML={{ __html: mindBodyCode }} />
        </FormWrapper>
      </Container>
    </BlockWrapper>
  );
};

export default MindBodyBrandedWebWidgetBlock;
